var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoLightCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.025 12.355c.924 0 1.646-.746 1.646-1.671 0-.938-.722-1.684-1.646-1.684-.911 0-1.645.746-1.645 1.684 0 .925.734 1.67 1.645 1.67zM13.925 23h5.15c.52 0 .925-.373.925-.9 0-.501-.405-.9-.924-.9h-1.57v-5.542c0-.694-.341-1.157-.987-1.157h-2.38a.904.904 0 0 0-.924.9c0 .527.405.9.924.9h1.355v4.9h-1.57a.904.904 0 0 0-.924.9c0 .526.405.899.924.899z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 27c6.018 0 11-4.993 11-11 0-6.018-4.993-11-11.01-11C9.981 5 5 9.982 5 16c0 6.007 4.993 11 11 11zm0-1.833c-5.09 0-9.156-4.077-9.156-9.167S10.9 6.833 15.99 6.833 25.156 10.91 25.167 16 21.09 25.167 16 25.167z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLightCircle);
export default __webpack_public_path__ + "static/media/Info-Light_Circle.ce4ed8ce252ce7bd52c93a010b08012a.svg";
export { ForwardRef as ReactComponent };